import type { RowData } from "@tanstack/react-table";
import { CellContext } from "@/lib/Components/DataTable/types";
import { TimeSinceNow } from "@/lib/Components/Common/TimeSinceNow";

export function TimeSinceNowCell<T extends RowData>({
  getValue,
}: CellContext<T, string>) {
  return (
    <div className="flex justify-end">
      <TimeSinceNow
        time={getValue()}
        className="whitespace-nowrap text-right text-xs text-gray-500"
      />
    </div>
  );
}

export function TimeSinceNowCompactCell<T extends RowData>({
  getValue,
}: CellContext<T, string>) {
  return (
    <div className="flex justify-end">
      <TimeSinceNow
        compact
        time={getValue()}
        className="whitespace-nowrap text-right text-xs text-gray-500"
      />
    </div>
  );
}
